"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactResponsive = require("react-responsive");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Link = _interopRequireDefault(require("../typography/Link"));

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MenuItem = _styledComponents.default.div.withConfig({
  displayName: "MenuItem",
  componentId: "sc-2hsgdq-0"
})(["display:flex;flex-direction:column;justify-content:center;background-color:", ";padding:8px 16px;color:", ";"], (0, _helpers.color)('brand'), (0, _helpers.color)('white'));

var DesktopMenuItem = (0, _styledComponents.default)(MenuItem).withConfig({
  displayName: "DesktopMenuItem",
  componentId: "sc-2hsgdq-1"
})(["height:3.5rem;margin-top:4px;"]);
var MobileMenuItem = (0, _styledComponents.default)(MenuItem).withConfig({
  displayName: "MobileMenuItem",
  componentId: "sc-2hsgdq-2"
})(["height:3rem;width:60px;align-items:center;font-size:1.5rem;"]);

var LogoMenuItem = function LogoMenuItem(_ref) {
  var desktop = _ref.desktop,
      mobile = _ref.mobile,
      _ref$link = _ref.link,
      Link = _ref$link === void 0 ? _Link.default : _ref$link,
      to = _ref.to,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["desktop", "mobile", "link", "to", "className"]);

  var isDesktop = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1040px)'
  });
  var Logo = isDesktop ? desktop : mobile;
  return _react.default.createElement(Link, _extends({
    to: to,
    className: className
  }, props), isDesktop ? _react.default.createElement(DesktopMenuItem, null, _react.default.createElement(Logo, {
    reversed: true
  })) : _react.default.createElement(MobileMenuItem, null, _react.default.createElement(Logo, null)));
};

var _default = LogoMenuItem;
exports.default = _default;